import React from 'react';
import { Box, Typography, Card, CardContent, Chip, List, ListItem, ListItemText } from '@mui/material';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Warning from '@mui/icons-material/Warning';
import Info from '@mui/icons-material/Info';
import Lightbulb from '@mui/icons-material/Lightbulb';

const InsightDisplay = ({ insights = [], recommendations = [] }) => {
  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'opportunity':
        return <TrendingUp color="success" />;
      case 'warning':
        return <Warning color="warning" />;
      case 'critical':
        return <Warning color="error" />;
      default:
        return <Info color="info" />;
    }
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'opportunity':
        return 'success';
      case 'warning':
        return 'warning';
      case 'critical':
        return 'error';
      default:
        return 'info';
    }
  };

  if (!insights.length && !recommendations.length) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }}>
      {insights.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Practice Insights
          </Typography>
          {insights.map((insight, index) => (
            <Card key={index} sx={{ mb: 1 }}>
              <CardContent sx={{ py: 1 }}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  {getSeverityIcon(insight.severity)}
                  <Typography variant="subtitle2" fontWeight="bold">
                    {insight.title}
                  </Typography>
                  <Chip 
                    label={insight.severity} 
                    size="small" 
                    color={getSeverityColor(insight.severity)}
                  />
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {insight.description}
                </Typography>
                {insight.metric_value && (
                  <Typography variant="caption" color="primary">
                    {insight.metric_value}{insight.metric_unit && ` ${insight.metric_unit}`}
                  </Typography>
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      )}

      {recommendations.length > 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Recommendations
          </Typography>
          {recommendations.map((rec, index) => (
            <Card key={index} sx={{ mb: 1 }}>
              <CardContent sx={{ py: 1 }}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <Lightbulb color="primary" />
                  <Typography variant="subtitle2" fontWeight="bold">
                    {rec.title}
                  </Typography>
                  <Chip label={rec.priority} size="small" variant="outlined" />
                </Box>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  {rec.description}
                </Typography>
                {rec.action_items && rec.action_items.length > 0 && (
                  <List dense sx={{ py: 0 }}>
                    {rec.action_items.map((item, itemIndex) => (
                      <ListItem key={itemIndex} sx={{ py: 0, px: 0 }}>
                        <ListItemText 
                          primary={`• ${item}`}
                          primaryTypographyProps={{ variant: 'caption' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default InsightDisplay;
